import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './TranslationsEditor.html?raw';
import "../WebTranslationsTypes";
import Edit from '../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

class TranslationsEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;

    protected timeoutHandle: number = null;

    editInput_Description: MdsLax<InstanceType<typeof Edit>>;
    editInput_Note: MdsLax<InstanceType<typeof Edit>>;
    checkboxInput_IsNonDefault: MdsLax<InstanceType<typeof CheckBox>>;
    checkboxInput_IsMultiline: MdsLax<InstanceType<typeof CheckBox>>;
    editInput_TextDE: MdsLax<InstanceType<typeof Edit>>;
    editInput_TextMultiDE: MdsLax<InstanceType<typeof Edit>>;
    editInput_TextEN: MdsLax<InstanceType<typeof Edit>>;
    editInput_TextMultiEN: MdsLax<InstanceType<typeof Edit>>;

    translationEditorErrorContainer: HTMLElement;
    translationEditorErrorMessage: HTMLElement;
    descriptionLockBtn: HTMLButtonElement;
    descriptionLockWarning: HTMLElement;

    saveBtnNode: HTMLElement;

    isLockedDescription: boolean = true;

    formData: WebTranslation_SaveEntity = {

        ID: "",
        is_new_entity: null,
        description: "",
        note: "",
        is_non_default: null,
        is_multiline: null,
        value_text_D: "",
        value_text_multiline_D: "",
        value_text_E: "",
        value_text_multiline_E: "",
    };
    originalData: string = "";

    isDirty: boolean = false;

    loadCatalogEntityData(data?: WebTranslation_Entity): void {

        if (data) {

            this.editInput_Description.setValue(data.description, true);
            this.isLockedDescription = true;

            this.editInput_Note.setValue(data.note, true);
            this.checkboxInput_IsNonDefault.setValue(data.is_non_default, true);
            this.checkboxInput_IsMultiline.setValue(data.is_multiline, true);
            this.editInput_TextDE.setValue(data.value_text_D, true);
            this.editInput_TextMultiDE.setValue(data.value_text_multiline_D, true);
            this.editInput_TextEN.setValue(data.value_text_E, true);
            this.editInput_TextMultiEN.setValue(data.value_text_multiline_E, true);

            this.formData.is_new_entity = false;
            this.formData.ID = data.ID;
        } else {

            this.editInput_Description.setValue("", true);
            this.isLockedDescription = false;

            this.editInput_Note.setValue("", true);
            this.checkboxInput_IsNonDefault.setValue(false, true);
            this.checkboxInput_IsMultiline.setValue(false, true);
            this.editInput_TextDE.setValue("", true);
            this.editInput_TextMultiDE.setValue("", true);
            this.editInput_TextEN.setValue("", true);
            this.editInput_TextMultiEN.setValue("", true);

            this.formData.is_new_entity = true;
            this.formData.ID = "";
        }

        this.lockDescriptionInput();

        this.serializeFormData();
        this.originalData = JSON.stringify(this.formData);
        console.debug("original data", this.originalData);

        this.checkDirty();
        this.checkMultilineDisable();
    }

    serializeFormData(): void {

        this.formData.description = this.editInput_Description.getValue();
        this.formData.note = this.editInput_Note.getValue();
        this.formData.is_non_default = this.checkboxInput_IsNonDefault.getValue();
        this.formData.is_multiline = this.checkboxInput_IsMultiline.getValue();
        this.formData.value_text_D = this.editInput_TextDE.getValue();
        this.formData.value_text_multiline_D = this.editInput_TextMultiDE.getValue();
        this.formData.value_text_E = this.editInput_TextEN.getValue();
        this.formData.value_text_multiline_E = this.editInput_TextMultiEN.getValue();


        console.debug("serialize data", this.formData);
    }

    checkMultilineDisable(): void {

        let isMultiline = this.checkboxInput_IsMultiline.getValue();

        if (isMultiline) {

            this.editInput_TextDE.setReadonly(true);
            this.editInput_TextEN.setReadonly(true);

            this.editInput_TextMultiDE.setReadonly(false);
            this.editInput_TextMultiEN.setReadonly(false);
        } else {

            this.editInput_TextDE.setReadonly(false);
            this.editInput_TextEN.setReadonly(false);

            this.editInput_TextMultiDE.setReadonly(true);
            this.editInput_TextMultiEN.setReadonly(true);
        }
    }

    checkDirty(): void {

        let isDirty = JSON.stringify(this.formData) !== this.originalData && this.originalData !== "";

        this.__delayDisableSaveButton(!isDirty);
        this.isDirty = isDirty;
    }

    protected __delayDisableSaveButton(disable: boolean): void {
        if (this.timeoutHandle != null) {
            clearTimeout(this.timeoutHandle);
            this.timeoutHandle = null;
        }

        this.timeoutHandle = setTimeout(lang.hitch(this, this.disableSaveButton, disable), 200);
    }

    disableSaveButton(disable: boolean): void {

        if (disable) {

            this.UiModder.domClass.add(this.saveBtnNode, "w3-disabled");
        } else {

            this.UiModder.domClass.remove(this.saveBtnNode, "w3-disabled");
        }
    }

    lockDescriptionInput(): void {

        if (this.isLockedDescription) {

            this.editInput_Description.setReadonly(true);
            this.descriptionLockBtn.innerHTML = `<i class="fas fa-lock-open"></i>`;

            this.UiModder.domClass.add(this.descriptionLockWarning, "w3-hide")
        } else {

            this.editInput_Description.setReadonly(false);
            this.descriptionLockBtn.innerHTML = `<i class="fas fa-lock"></i>`;

            this.UiModder.domClass.remove(this.descriptionLockWarning, "w3-hide")
        }
    }

    saveTranslationData(): void {

        this._showErrorMessage(false);

        let requestUrl = window.appRoot + "WebTranslations/SaveTranslationData";
        this.StandbyStart();

        this.RequestManager.post(
            requestUrl,
            {
                jsonData: JSON.stringify(this.formData)
            },
            lang.hitch(this, this._onSaveTranslationDataResponse),
            lang.hitch(this, this._onSaveTranslationDataError),
            false // sync
        );
    }

    _onSaveTranslationDataResponse(): void {

        this.StandbyStop();

        let dlg = new GenericDialog();

        dlg.destroyOnClose = true;
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "margin-top", "100px");

        dlg.show(this.translations["FormDialog_Save_Message"], this.translations["FormDialog_Save_Header"], null, "fas fa-info-circle", "ok");

        this.emit("Translation_Save");
    }

    _onSaveTranslationDataError(err): void {

        this.StandbyStop();
        this._showErrorMessage(true, err.Message);
    }

    _onClick_DescriptionLockBtn(): void {

        this.isLockedDescription = !this.isLockedDescription;
        this.lockDescriptionInput();
    }

    _onChangeInputData(): void {

        this.serializeFormData();
        this.checkDirty();
        this.checkMultilineDisable();
    }

    _onChangeNoteTextAreaInputData(): void {

        let note: string = this.editInput_Note.getValue();

        note = note.replace(/[\r\n]/g, "\r\n");

        this.editInput_Note.setValue(note, true);
        
        this.serializeFormData();
        this.checkDirty();
    }

    _onChangeTextDeTextAreaInputData(): void {

        let textDe: string = this.editInput_TextMultiDE.getValue();

        textDe = textDe.replace(/[\r\n]/g, "\r\n");

        this.editInput_TextMultiDE.setValue(textDe, true);
        
        this.serializeFormData();
        this.checkDirty();
    }

    _onChangeTextEnTextAreaInputData(): void {

        let textEn: string = this.editInput_TextMultiEN.getValue();

        textEn = textEn.replace(/[\r\n]/g, "\r\n");
        this.editInput_TextMultiEN.setValue(textEn, true);
        
        this.serializeFormData();
        this.checkDirty();
    }

    _onClick_saveBtn(): void {

        this.serializeFormData();
        this.checkDirty();

        if (this.formData.description && this.isDirty) {

            this.saveTranslationData();
        } else {

            this.__delayDisableSaveButton(true);
        }
    }

    _showErrorMessage(bool: boolean, msg?: string) {

        if (bool) {

            this.UiModder.domClass.remove(this.translationEditorErrorContainer, "w3-hide");
            msg ? this.translationEditorErrorMessage.innerHTML = msg : this.translationEditorErrorMessage.innerHTML = "...error occured";
        } else {

            this.UiModder.domClass.add(this.translationEditorErrorContainer, "w3-hide");
            this.translationEditorErrorMessage.innerHTML = "";
        }
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(TranslationsEditor.prototype, {
  editInput_Description: () => (new Edit()),
  editInput_Note: () => (new Edit()),
  checkboxInput_IsNonDefault: () => (new CheckBox()),
  checkboxInput_IsMultiline: () => (new CheckBox()),
  editInput_TextDE: () => (new Edit()),
  editInput_TextMultiDE: () => (new Edit()),
  editInput_TextEN: () => (new Edit()),
  editInput_TextMultiEN: () => (new Edit()),
});
export default mdsWidget(TranslationsEditor);